import CallHistory from "./CallHistory";
import React, { useEffect } from "react";
import { Col } from "reactstrap";
import { Card } from "../../../../ui";
import Home from "./Home/Home";
import FindTeacher from "./findTeacher";
import DeductedClassDetails from "./detuctedFile";
import StudentHistory from "./studentHistory";
import WalletDetails from "./walletDetails";
import ExternalPayment from "./payment/externalPayment";
import SplitPaymentList from "../../../../Pages/SplitPayment/SplitPaymentList";
import AeForm from "./aeForm";
import TransactionList from "./transactionList";
import Calendar from "./Calander/calendar";
import ProfileForm from "./profileForm";
import NewPaymentLink from "./payment/new-paymentlink";
import KYSForm from "./kys-form";
import { studentProfile } from "../../../../Api/apiUtils";
import Subscription from "./Home/subscription";
import ChangeCourse from "./ChangeCourse/change-course";
import ClassDetails from "./classDetails";
import ChangeCourseWithTabs from "./ChangeCourse/changecoursetab";
import ClassHistory from "./ClassHistory/classhistory";
import CourseCertificate from "./Certificate/certificate";
import ChatbotLauncher from "./chatbot/ChatbotLauncher";
import AddStudentChats from "./AiSummary/aiConvo";
import AiSummaryCard from "../../Tasks/AiSummaryCard";
import RmSection from "../../Tasks/RmSection";
import LearnerTaskList from "../../Tasks/LearnerTaskList";
import MarkLessons from "./Lessons/markLessons";
import CourseExtension from "./payment/course-extension";
import RmHistory from "./RmHistory";
import TransactionChange from "./TransactionCourseChange/transaction-change";
interface MainContentProps {
  activeTab: string;
  credentialId: any;
  studentId: any;
  selectedTeacherId:any
  selectedTeacherName:any
  selectedExpiry:any
  userId: any;
  /** CMS userId, resolved by the profile page — the route has no userId. */
  cmsUserId?: string;
  selectedCourse: any;
  selectedCourseData:any
  userType: string; 
  courseData: any;
  courseCounts: {
    unscheduledClasses: number;
    completedClasses: number;
    scheduledClasses: number;

  }
  fetchCourses: () => Promise<void>; 
  };

const MainContent: React.FC<MainContentProps> = ({ selectedCourseData,activeTab, studentId, credentialId, userId, cmsUserId: cmsUserIdProp, selectedExpiry, userType, courseCounts, selectedCourse,  fetchCourses, courseData, selectedTeacherId, selectedTeacherName }) => {

  console.log("coursedataprofile", selectedCourseData);

  const [profileData, setProfileData] = React.useState<any>(null);

  useEffect(() => {
    const fetchProfileData = async () => {
      setProfileData(await studentProfile(credentialId, studentId));
    };

    fetchProfileData();
  }, []);


  console.log(`Active Tab in MainContent: ${activeTab}`);
  /**
   * The CMS userId, which is what the RM tool keys learners by. The route
   * (/student-profile/:credentialId/:studentId) carries no userId, so the
   * `userId` prop is undefined here — the course data holds it, and that's
   * what the Notes tab reads too.
   */
  const cmsUserId = String(
    cmsUserIdProp || (selectedCourseData as any)?.studentUserId || (profileData as any)?.userId || userId || '',
  );

  const renderContent = () => {
    const tab = activeTab.trim().toLowerCase();
    switch (tab) {
      case "profile":
        return <Home activeTab={activeTab} credentialId={credentialId} studentId={studentId}
         courseCounts={courseCounts} selectedCourseData={courseData} 
        selectedCourse={selectedCourse}  fetchCourses={fetchCourses}  selectedCourseDetails={selectedCourseData}/> ;

      case "find teacher":
        return <FindTeacher profileData={profileData} studentId={studentId} fetchCourses={fetchCourses} showBookAllClasses />;
      case "deducted class details":
        return <DeductedClassDetails />;
      case "student history":
        return <StudentHistory studentId={studentId} profileData={profileData} />;
      case "wallet details":
        return <WalletDetails credentialId={credentialId} studentId={studentId} studentData={profileData}  />;

        case "capture manual payment":
          return <ExternalPayment studentId={studentId} profileData={profileData} />;
        case "split payment":
          return <SplitPaymentList credentialId={credentialId} studentId={studentId} profileData={profileData} />;
          case "course extension":
            return <CourseExtension courseData={courseData} studentId={studentId} profileData={profileData} />;
          case "ae form":
            return <AeForm  studentId={studentId} />;
            case "kys form":
              return <KYSForm profileData={profileData} courseId={selectedCourse} />;
            case "transaction list":
              return <TransactionList studentId={studentId}  />;
              case "payment link":
              return < NewPaymentLink studentId={studentId} profileData={profileData}  />;
              case "class details":
                return <ClassDetails studentId={studentId} courseId={selectedCourse} />;
              case "calendar":
                return <Calendar courseExpiry={selectedExpiry} courseData={selectedCourseData} studentCourses={courseData} selectedTeacherName={selectedTeacherName} selectedCourseData={selectedTeacherId} courseCounts={courseCounts} fetchCourses={fetchCourses} courseId={selectedCourse}  profileData={profileData} studentId={studentId} credentialId={credentialId} />;
        
                  case "teacher change":
                    return <Subscription courseData={courseData} studentId={studentId} fetchCourses={fetchCourses} profileData={profileData}  />;

                  case "complete level":
                    return (
                      <ChangeCourseWithTabs
                        studentUserId={userId}
                        profileData={profileData}
                        studentId={studentId}
                        courseData={courseData}
                      />
                    );
                  case "course change":
                    return (
                      <TransactionChange
                        studentId={studentId}
                        profileData={profileData}
                        userType={userType}
                      />
                    );
                    case "lessons":
                      return <MarkLessons  courseId={selectedCourse} profileData={profileData}/>;
                    case "certificates":
                      return <CourseCertificate  courseId={selectedCourse} profileData={selectedCourseData}  />;
                     case "class history":
                      return <ClassHistory studentId={studentId} courseId={selectedCourse} selectedCourseData={selectedCourseData} />;

                      case "call history":
                        return <CallHistory profileData={profileData} />;
                      case "renewal info":
                        return <RmHistory studentUserId={cmsUserId} />;
                      case "journey summary":
                        return (
                          <Card
                            title="Journey summary"
                            subtitle="What this learner's support history says each month — tickets, chat, calls, PTM notes and class ratings, summarised for the RM."
                          >
                            {cmsUserId ? (
                              <AiSummaryCard
                                studentExternalId={cmsUserId}
                                variant="history"
                                boxed={false}
                              />
                            ) : (
                              <p className="ds-text-subtle">
                                Still loading this learner&apos;s details — reopen this section
                                in a moment.
                              </p>
                            )}
                          </Card>
                        );
                      case "tasks":
                        return (
                          <Card
                            title="Tasks"
                            subtitle="Every ticket raised for this learner, newest first."
                          >
                            {cmsUserId ? (
                              <LearnerTaskList studentExternalId={cmsUserId} />
                            ) : (
                              <p className="ds-text-subtle">
                                Still loading this learner&apos;s details — reopen this
                                section in a moment.
                              </p>
                            )}
                          </Card>
                        );
                      case "relationship manager":
                        return (
                          <Card
                            title="Relationship Manager"
                            subtitle="Who owns this learner, and every change of hands."
                          >
                              {cmsUserId ? (
                                <RmSection
                                  profile={{
                                    studentExternalId: cmsUserId,
                                    name:
                                      [profileData?.firstName, profileData?.lastName]
                                        .filter(Boolean)
                                        .join(" ")
                                        .trim() ||
                                      String(
                                        (selectedCourseData as any)?.studentName ||
                                          profileData?.studentName ||
                                          "",
                                      ).trim(),
                                    // Both halves or nothing — a country code
                                    // without a number is not a phone number.
                                    phone:
                                      profileData?.countryCode && profileData?.mobileNumber
                                        ? `+${String(profileData.countryCode).replace(/\D/g, "")}${String(
                                            profileData.mobileNumber,
                                          ).replace(/\D/g, "")}`
                                        : undefined,
                                    email: profileData?.emailId || undefined,
                                    timezone: profileData?.timezone || undefined,
                                    credentialId: credentialId ? String(credentialId) : undefined,
                                    studentId: studentId ? String(studentId) : undefined,
                                  }}
                                />
                              ) : (
                                <p className="ds-text-subtle">
                                  Still loading this learner&apos;s details — reopen this
                                  section in a moment.
                                </p>
                              )}
                          </Card>
                        );
                      case "notes" :
                      return <AddStudentChats  fullProfileData={profileData}   credentialId={credentialId} studentProfileData={selectedCourseData}  />;
                      // case "Chatbot":
                      //   return <ChatbotLauncher/>
      default:
        return <Home activeTab={activeTab}  selectedCourseDetails={selectedCourseData} credentialId={credentialId}
         studentId={studentId} courseCounts={courseCounts}  selectedCourseData={courseData}
          selectedCourse={selectedCourse}   fetchCourses={fetchCourses}/>;
    }
  };  
  return (
    <Col xs="12" xl="10" className="student-profile-main-col">
      <Card className="student-profile-main">
        <div className="student-profile-main-body">{renderContent()}</div>
      </Card>
    </Col>
  );
};

export default MainContent;